import { Component, OnInit, ViewChild } from '@angular/core';
import { EncuestaService } from '../../../services/encuesta.service';
import { EncuestaDTO } from '../../../dto/encuesta/encuesta.dto';
import { PreguntaDTO } from '../../../dto/encuesta/preguntas.dto';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreguntasComponent } from '../preguntas/preguntas.component';
import { UtilService } from '../../../services/util.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { RespuestaEncuestaDto } from '../../../dto/encuesta/respuesta-encuesta.dto';
import { RequestFiltersContarDatos } from '../../../dto/powerbi/request.filters.contardatos.dto';
import { PowerbiService } from '../../../services/powerbi.service';

@Component({
  selector: 'app-administracion-encuestas',
  templateUrl: './administracion-encuestas.component.html',
  styleUrl: './administracion-encuestas.component.scss',
})
export class AdministracionEncuestasComponent implements OnInit {
  public encuestas: EncuestaDTO[] = [];
  public idEncuesta: number | null = null;
  public preguntas: PreguntaDTO[] = [];
  public respuestas: RespuestaEncuestaDto[] = [];
  public encuestaForm: FormGroup;
  public showModal = false;
  public encuestaSeleccionada: EncuestaDTO | any = null;
  public columnas: TableColumn[] = [];
  public columnasRespuestas: TableColumn[] = [];
  public acciones: TableAction[] = [];

  public tableText: any = {};
  public tituloPrincipal: string = '';
  public seleccioneTitulo: string = '';
  public seleccioneEncuesta: string = '';
  public descripcionEncuesta: string = '';
  public mensajeEntrada: string = '';
  public saveSurvey: string = '';
  public preguntasTexto: string = '';
  public respuestasTexto: string = '';
  public crearPreguntaTexto: string = '';
  mostrarTablaRespuestas = false;
  textoPreguntaFilter = '';
  fechaInicio = '';
  fechaFin = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly encuestaService: EncuestaService,
    private readonly utilService: UtilService,
    private readonly ngModalService: NgbModal,
    private readonly alertaModalServce: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly pbiService: PowerbiService,
  ) {
    this.encuestaForm = this.formBuilder.group({
      descripcion: ['', Validators.required],
      mensaje: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.translate.stream('encuestas').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this.tituloPrincipal = this.tableText['titulo-principal'];
      this.seleccioneTitulo = this.tableText['seleccionar-titulo'];
      this.seleccioneEncuesta = this.tableText['seleccionar-encuesta'];
      this.descripcionEncuesta = this.tableText['descripcion-encuesta'];
      this.mensajeEntrada = this.tableText['mensaje-entrada'];
      this.saveSurvey = this.tableText['guardar-encuesta'];
      this.preguntasTexto = this.tableText['preguntas'];
      this.respuestasTexto = this.tableText['respuestas'];
      this.crearPreguntaTexto = this.tableText['crear-pregunta'];
      this.getEncuestas();
      this.initColumns();
    });
  }

  initColumns() {
    this.columnas = [
      {
        field: 'Indice',
        title: '#',
        type: 'text',
        filterable: false,
        sortable: false,
        width: '6rem',
      },
      {
        field: 'Descripcion',
        title: this.tableText['descripcion'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '22rem',
      },
      {
        field: 'Estado_Text',
        title: this.tableText['estado'],
        type: 'text',
        enabledAction: 'true',
        filterable: false,
        sortable: false,
        width: '6rem',
      },
      {
        field: 'Tipo_Campo',
        title: this.tableText['tipo-campo'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '6rem',
      },
    ];
    this.columnasRespuestas = [
      {
        field: 'Respuesta',
        title: this.tableText['respuesta'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '20rem',
      },
      {
        field: 'Encuesta_Usuario.Fecha_Diligenciamiento',
        title: this.tableText['fecha-diligenciamiento'],
        type: 'date',
        filterable: true,
        sortable: true,
        width: '15rem',
        fieldFilterElement: 'Fecha_Diligenciamiento',
        pipe: 'dd/MM/yyyy HH:mm',
      },
    ];
    // Columna de acciones
    this.acciones = [
      {
        type: 'button',
        icon: 'edit',
        title: this.tableText['acciones'],
        idAccion: '1',
      },
      {
        type: 'button',
        icon: 'eye',
        title: this.tableText['acciones'],
        idAccion: '2',
      },
    ];
  }

  getEncuestas() {
    this.encuestaService.getListarEncuestas().subscribe(data => {
      this.encuestas = data.map(encuesta => ({
        ...encuesta,
        Preguntas: encuesta.Preguntas
      }));
      this.onEncuestaChange();
    });
  }

  getRespuestasPregunta(body: any){
    this.encuestaService.getListarRespuestasEncuesta(body).subscribe(data => {
      this.respuestas = data;
    });
  }

  onEncuestaChange(): void {
    if (this.idEncuesta) {
      this.fechaInicio = '';
      this.fechaFin = '';
      this.encuestaSeleccionada = this.encuestas.find(
        encuesta => encuesta.Id === Number(this.idEncuesta)
      );

      if (this.encuestaSeleccionada) {
        this.preguntas = this.encuestaSeleccionada.Preguntas || [];
        this.preguntas.map((pregunta, indice) => {
          pregunta.Indice = indice + 1;
          pregunta.Estado_Text = pregunta.Estado
            ? this.tableText['estado-activo']
            : this.tableText['estado-inactivo'];
        });

        this.encuestaForm
          .get('descripcion')
          ?.patchValue(this.encuestaSeleccionada.Descripcion);
        this.encuestaForm
          .get('mensaje')
          ?.patchValue(this.encuestaSeleccionada.Mensaje_Entrada);
      } else {
        this.preguntas = [];
        this.encuestaForm.reset();
      }
    }
  }

  accionesPregunta(event: any) {
    if(event.idAccion === '1'){
      this.mostrarTablaRespuestas = false;
      this.utilService.setPregunta(event.item);
      const pregunta = event.item;
      this.utilService.setPregunta(pregunta);
      this.utilService.setIndexPregunta(event.index);
      this.utilService.setEncuesta(this.encuestaSeleccionada);
      this.open(false);
    }else{
      this.mostrarTablaRespuestas = true;
      this.textoPreguntaFilter = event.item.Descripcion;
      const body = {
        filtros: {
          Texto_Pregunta: this.textoPreguntaFilter,
        }
      };
      this.getRespuestasPregunta(body);
    }
  }

  filtrarRespuestas(event: any) {
    event.filtros['Texto_Pregunta'] = this.textoPreguntaFilter;
    console.log('event', event);
    this.getRespuestasPregunta(event);
  }

  guardarEncuesta() {
    this.encuestaSeleccionada.Preguntas = this.preguntas;
    this.encuestaSeleccionada.Descripcion =
      this.encuestaForm.get('descripcion')?.value;
    this.encuestaSeleccionada.Mensaje_Entrada =
      this.encuestaForm.get('mensaje')?.value;
    this.encuestaSeleccionada.Fecha_Actualizacion = new Date();
    this.encuestaService
      .actualizarEncuesta(
        this.encuestaSeleccionada.Id,
        this.encuestaSeleccionada
      )
      .subscribe(() => {
        this.getEncuestas();
      });
  }

  habilitarEncuesta(){
    this.encuestaSeleccionada.Estado = !this.encuestaSeleccionada.Estado;
    this.encuestaSeleccionada.Fecha_Actualizacion = new Date();

    this.encuestaService.actualizarEncuesta(
      this.encuestaSeleccionada.Id,
      this.encuestaSeleccionada
    ).subscribe(() => {
      this.getEncuestas();
    });
  }

  cerrarEncuesta(){
    this.encuestaSeleccionada.Cerrada = true;
    this.encuestaSeleccionada.Fecha_Actualizacion = new Date();

    this.encuestaService.actualizarEncuesta(
        this.encuestaSeleccionada.Id,
        this.encuestaSeleccionada
    ).subscribe(() => {
      this.getEncuestas();
    });
  }

  crearPregunta() {
    this.utilService.setPregunta(null);
    this.utilService.setIndexPregunta(null);
    this.utilService.setEncuesta(this.encuestaSeleccionada);
    this.open(true);
  }

  open(isNew: boolean) {
    const modalRef = this.ngModalService.open(PreguntasComponent, {
      size: 'lg',
      windowClass: 'modal-xl',
      backdrop: 'static', // Evita el cierre al hacer clic fuera
      keyboard: false // Lo mismo pero con Esc
    });
    modalRef.componentInstance.isNewItem = isNew;
    modalRef.result.then(
      (data) => {
        if (data) {
          this.getEncuestas();

          this.alertaModalServce.exito(data).then(() => {
          });
        }
      },
      (reason) => {
        setTimeout(() => {
          this.getEncuestas();
        }, 500);
      }
    );
  }

  downloadExcel() {
    const filters: RequestFiltersContarDatos[] = [
      {
        name: 'Id_Encuesta',
        value: `${this.idEncuesta}`,
      },
      {
        name: 'Fecha_Inicio',
        value: this.fechaInicio,
      },
      {
        name: 'Fecha_Fin',
        value: this.fechaFin,
      },
    ];
    this.pbiService.exportRespuestasEncuesta(filters).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'Respuestas_Encuesta.xlsx'; // Nombre del archivo que se descargará
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);
        if (response) {
          this.alertaModalServce.exito(
            this.tableText['exito'],
            this.tableText['descarga-archivo']
          );
        }
      },
      error => {
        this.alertaModalServce.error(this.tableText['error-descarga']);
        console.error(error);
      }
    );
  }
}
